module.exports = __webpack_public_path__ + "static/media/debug.349d7149.svg";